import { Link } from "react-router-dom";
import "./index.scss";

const Breadcrumb = ({ items, color }) => {
  return (
    <nav aria-label="breadcrumb">
      <ul className="breadcrumb mobile">
        {items.slice(-2, -1).map((item, index) => (
          <li key={index} className="item" style={{ color: color }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="currentColor"
            >
              <path
                d="M7.52655 8.00001L9.88655 5.64001C10.145 5.37998 10.145 4.96003 9.88655 4.70001C9.76137 4.5738 9.59097 4.50281 9.41321 4.50281C9.23546 4.50281 9.06506 4.5738 8.93988 4.70001L6.11321 7.52667C5.98701 7.65185 5.91602 7.82225 5.91602 8.00001C5.91602 8.17776 5.98701 8.34816 6.11321 8.47334L8.93988 11.3333C9.06569 11.4581 9.23601 11.5277 9.41321 11.5267C9.59042 11.5277 9.76074 11.4581 9.88655 11.3333C10.145 11.0733 10.145 10.6534 9.88655 10.3933L7.52655 8.00001Z"
                fill="currentColor"
              />
            </svg>
            {item.href ? (
              <Link
                to={item.href}
                style={{ textDecoration: "none", color: color }}
              >
                {item.label}
              </Link>
            ) : (
              <span>{item.label}</span>
            )}
          </li>
        ))}
      </ul>
      <ul className="breadcrumb desktop">
        {items.map((item, index) => (
          <li key={index} className="item" style={{ color: color }}>
            {item.href ? (
              <Link
                to={item.href}
                style={{ textDecoration: "none", color: color }}
              >
                {item.label}
              </Link>
            ) : (
              <span>{item.label}</span>
            )}
            {index < items.length - 1 && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="currentColor"
              >
                <path
                  d="M9.88663 8.02582L7.05996 5.19915C6.93478 5.07294 6.76439 5.00195 6.58663 5.00195C6.40887 5.00195 6.23847 5.07294 6.1133 5.19915C5.85481 5.45918 5.85481 5.87913 6.1133 6.13915L8.4733 8.49915L6.1133 10.8592C5.85481 11.1192 5.85481 11.5391 6.1133 11.7992C6.23911 11.9239 6.40943 11.9935 6.58663 11.9925C6.76383 11.9935 6.93415 11.9239 7.05996 11.7992L9.88663 8.97249C10.0128 8.84731 10.0838 8.67691 10.0838 8.49915C10.0838 8.32139 10.0128 8.151 9.88663 8.02582Z"
                  fill="currentColor"
                />
              </svg>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Breadcrumb;
